/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the header component
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

import { NavLink, useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



/**
 * Used to create a style hook to utilise JSS
 */
import { Theme, makeStyles } from '@material-ui/core/styles';

/**
 * Used to signify the header as the appbar of the application.
 */

/**
 * Used to restrict the content width of the header.
 */

/**
 * Used to layout the header.
 */

/**
 * Used to layout the header.
 */

/**
 * Used to format text.
 */

/**
 * Used to style navigation.
 */

/**
 * Used to style links in the navigation.
 */
import Button from '@material-ui/core/Button';



/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Used to get the BCT Website URL.
 */

/*
 * ---------------------------------------------------------------------------------
 * Assets
 * ---------------------------------------------------------------------------------
 */



import { faBuilding } from '@fortawesome/pro-duotone-svg-icons/faBuilding';
import { faFileAlt } from '@fortawesome/pro-duotone-svg-icons/faFileAlt';
import { ALL_INSTITUTIONS, ALL_INSTITUTIONS_CODE, InstitutionContext, onlinePatientManagement } from '@ngt/online-patient-management-ui';
import BreadcrumbContainer from './BreadcrumbContainer';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

interface ISaeBreadcrumbsProps {
    institutionName?: string;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles<Theme>(theme => ({
    navLink: {
        borderRadius: 50,
        fontSize: '0.75rem',
        fontWeight: 500,
        textTransform: 'none',
        margin: theme.spacing(0.25, 0),

        // '&:hover': {
        //     backgroundColor: onlinePatientManagement.colors.secondary[50]
        // }
    },
}));

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

const SaeBreadcrumbs: React.FunctionComponent<ISaeBreadcrumbsProps> = ({
    institutionName
}) => {
    const classes = useStyles();

    const params = useParams();

    const saeNumberParam = 'saeNumber';

    const institutionCode = params[onlinePatientManagement.routeParameters.institutionCode] ?? ALL_INSTITUTIONS_CODE;

    const [institutionState] = React.useContext(InstitutionContext);

    const institution = institutionCode !== ALL_INSTITUTIONS_CODE ? institutionState?.name ?? institutionName : ALL_INSTITUTIONS;

    const institutionLink = institutionCode !== ALL_INSTITUTIONS_CODE ? `/sae/${institutionCode}` : `/sae/`;

    const patientStudyNumber = params[onlinePatientManagement.routeParameters.patientStudyNumber]

    const saeNumber = params[saeNumberParam];

    const saeLink = institutionCode !== ALL_INSTITUTIONS_CODE ? `/sae/${institutionCode}/${patientStudyNumber}/${saeNumber}` : `/sae/`;

    return (
        <BreadcrumbContainer>
            {
                !!institution && (
                    <Button
                        component={NavLink}
                        to={institutionLink}
                        color="inherit"
                        className={classes.navLink}
                        activeClassName={classes.navLinkActive}
                        startIcon={<FontAwesomeIcon icon={faBuilding} fixedWidth />}
                        size="small"
                    >
                        {institution}
                    </Button>
                )
            }

            {
                !!patientStudyNumber && !!saeNumber && (
                    <Button
                        component={NavLink}
                        to={saeLink}
                        color="inherit"
                        className={classes.navLink}
                        activeClassName={classes.navLinkActive}
                        startIcon={<FontAwesomeIcon icon={faFileAlt} fixedWidth />}
                        size="small"
                    >
                        {patientStudyNumber}(SAE No.{saeNumber})
                    </Button>
                )
            }
        </BreadcrumbContainer>
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default SaeBreadcrumbs;